export default "__VITE_ASSET__nNvJ0ntY__"